import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 3rem;
  margin-bottom: 35rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 2rem;
    margin-bottom: 30rem;
  }
`;

export const Img1 = styled.img`
  width: 100%;
  height: 64rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    height: 17.5rem;
  }
`;
